export default __webpack_public_path__ + "static/media/agrodriveIcon.6ee25af0.svg";